'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = computors;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function computors(target) {
  target.computors = (0, _extends3.default)({}, target.computors, {
    series: R.sortWith([R.ascend(target.accessors.baselineIndex), R.ascend(target.accessors.highlightIndex)]),
    linesData: function linesData(serie) {
      var datapoints = serie.datapoints;
      var _split = R.reduce(function (acc, dp) {
        if (R.isNil(dp.y)) {
          return R.append([], acc);
        }
        return R.over(R.lensIndex(-1), R.append(dp))(acc);
      }, [[]], datapoints);
      var split = R.reject(R.isEmpty, _split);
      return R.map(function (datapoints) {
        return (0, _extends3.default)({}, serie, {
          datapoints: datapoints
        });
      }, split);
    },
    markersData: function markersData(serie) {
      return R.pipe(R.propOr([], 'datapoints'), R.reject(function (dp) {
        return R.isNil(dp.y);
      }))(serie);
    }
  });
}